export const ALLOWANCE_DEFAULT_REGION = { name: 'Portugal', code: 1 };
export const ALLOWANCE_ISLANDS_REGION = { name: 'Regiões Autónomas', code: 2 };
export const ALLOWANCE_OTHER_COUNTRY_REGION = { name: 'Estrangeiro', code: 3 };

export const ALLOWANCE_REGIONS = [
    { name: 'Portugal', code: 1 },
    //{ name: 'Regiões Autónomas', code: 2},
    { name: 'Estrangeiro', code: 3 }
];

export const ALLOWANCE_DAILY_TYPE_25 = 1;
export const ALLOWANCE_DAILY_TYPE_50 = 2;
export const ALLOWANCE_DAILY_TYPE_75 = 3;
export const ALLOWANCE_DAILY_TYPE_100 = 4;
export const ALLOWANCE_DAILY_TYPE_MEAL = 5;